import Vue from 'vue';
import VueI18n from 'vue-i18n';
import it from '@/i18n/it.json';

Vue.use(VueI18n);

const messages = {
    it: {
        ...it
    }
};

export const i18n = new VueI18n({
    locale: 'it',
    fallbackLocale: 'it',
    messages,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
});
